module.exports = __webpack_public_path__ + "static/media/02.aebad533.webp";